// extracted by mini-css-extract-plugin
module.exports = {"link":"CropsLink_link__2Rxk4"};